import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const BulkRequest = () => {
  const [requestDetails, setRequestDetails] = useState("");
  const [selectedAccount, setSelectedAccount] = useState(sessionStorage.getItem("selectedAccount") || "");
  const [openDialog, setOpenDialog] = useState(false);
  const [hrDetails , setHrDetails] = useState([]);
  const handleInputChange = (event) => {
    setRequestDetails(event.target.value);
  };

  const handleSendRequest = async () => {
    try {
      const response = await fetch("https://api.cri.co.in/api/bulkRequests", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          requestDetails,
          selectedAccount,
        }),
      });

      if (response.ok) {
        setOpenDialog(true);
        setRequestDetails(""); // Clear the input after sending the request
      } else {
        console.error("Failed to send bulk request" , response);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };


  const fetchHrDetails = async () => {
    try {
      const response = await fetch(`https://api.cri.co.in/api/notifications/${selectedAccount}`); // Fetch HR details based on account ID
      if (response.ok) {
        const data = await response.json();
        setHrDetails(data);
      } else {
        console.error("Failed to fetch HR details", response);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Fetch HR details when the component mounts
  useEffect(() => {
    if (selectedAccount) {
      fetchHrDetails();
    }
  }, [selectedAccount]);

  return (
    <Box
      sx={{
        maxWidth: 600,
        margin: "auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        style={{ fontWeight: "bold", marginBottom: "20px" }}
      >
        Bulk E-Card Request to Admin
      </Typography>
      <TextField
        label="Enter Request Details"
        placeholder="Describe your bulk request here..."
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        value={requestDetails}
        onChange={handleInputChange}
        sx={{
          marginBottom: "20px",
        }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        endIcon={<SendIcon />}
        onClick={handleSendRequest}
        disabled={!requestDetails.trim()} // Disable button if input is empty
        sx={{
          padding: "10px 0",
          fontWeight: "bold",
          fontSize: "16px",
          textTransform: "none",
          backgroundColor: "#007bff",
          "&:hover": {
            backgroundColor: "#0056b3",
          },
        }}
      >
        Send Request to Admin
      </Button>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle>{"Request Sent"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your bulk request has been sent to the admin successfully!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* HR Details Section */}
      {/* HR Details Section */}
{hrDetails.length > 0 && (
  <Box sx={{ marginTop: "40px" }}>
    <Typography variant="h5" gutterBottom sx={{ color: "#007bff", fontWeight: "bold" }}>
      HR Details for Selected Account
    </Typography>
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "15px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#007bff" }}>
            <TableCell sx={{ color: "#fff", fontWeight: "bold", padding: "15px" }}>S.No</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold", padding: "15px" }}>HR Name</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold", padding: "15px" }}>TPA Name</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold", padding: "15px" }}>Descriptioon</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold", padding: "15px" }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {hrDetails.map((detail, index) => (
            <TableRow
              key={detail._id}
              sx={{
                "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                "&:nth-of-type(even)": { backgroundColor: "#e3f2fd" },
              }}
            >
              <TableCell sx={{ padding: "15px" }}>{index + 1}</TableCell>
              <TableCell sx={{ padding: "15px" }}>{detail.hrName}</TableCell>
              <TableCell sx={{ padding: "15px" }}>{detail.tpaName}</TableCell>
              <TableCell sx={{ padding: "15px" }}>{detail.description}</TableCell>
              <TableCell
                sx={{
                  padding: "15px",
                  fontWeight: "bold",
                  color: detail.status === "Done" ? "green" : "red",
                }}
              >
                {detail.status}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
)}

    </Box>
  );
};

export default BulkRequest;
